__turbopack_context__.v({
  "btnCarouselController": "_6DdgAq_btnCarouselController",
  "carouselControllerContainer": "_6DdgAq_carouselControllerContainer",
  "container": "_6DdgAq_container",
  "contentContainer": "_6DdgAq_contentContainer",
  "dotsIndicatorContainer": "_6DdgAq_dotsIndicatorContainer",
  "footerViewAll": "_6DdgAq_footerViewAll",
  "headersAndViewAll": "_6DdgAq_headersAndViewAll",
  "inverse": "_6DdgAq_inverse",
  "modal": "_6DdgAq_modal",
  "modalClose": "_6DdgAq_modalClose",
  "modalContent": "_6DdgAq_modalContent",
  "modalContentBody": "_6DdgAq_modalContentBody",
  "remark": "_6DdgAq_remark",
  "remarkWrapper": "_6DdgAq_remarkWrapper",
  "remarksAndQuoteContainer": "_6DdgAq_remarksAndQuoteContainer",
  "remarksCarousel": "_6DdgAq_remarksCarousel",
  "remarksContainer": "_6DdgAq_remarksContainer",
  "seeMore": "_6DdgAq_seeMore",
  "starsContainer": "_6DdgAq_starsContainer",
  "username": "_6DdgAq_username",
  "viewAll": "_6DdgAq_viewAll",
});
